import Swiper, { Navigation } from "swiper";
import { sizesValues } from "../../assets/vars/sizes";

export const swiperCreateNew = (sectionId) => {
	const thisSection = document.getElementById(sectionId);
	const swiperElem = thisSection?.querySelector(".swiper");
	const galleryPagination = thisSection?.querySelector(
		".custom-slider-pagination"
	);

	const thisSwiper = new Swiper(swiperElem, {
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 25,
		navigation: {
			nextEl: galleryPagination?.querySelector("button.next"),
			prevEl: galleryPagination?.querySelector("button.prev"),
		},
		breakpoints: {
			[sizesValues.md]: {
				slidesPerView: 2,
			},
			[sizesValues.lg]: {
				slidesPerView: 2.5,
			},
			[sizesValues.xxl]: {
				slidesPerView: 3.5,
			},
			[sizesValues.xxxl]: {
				slidesPerView: 3.5,
			},
			[sizesValues.maxl]: {
				slidesPerView: 3.5,
			},
		},
	});

	return thisSwiper;
};
